import * as React from 'react';
import { pluralize } from '@cian/newbuilding-utils';
import { UIText1 } from '@cian/ui-kit';

import { IconActionArrowRight16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './styles.css';

interface IBuilderLinkBlockProps {
  count: number;
  url: string;
  newbuildingText: string;
  type: 'done' | 'inProgress';
}

export function BuilderLinkBlock({ count, url, newbuildingText, type }: IBuilderLinkBlockProps) {
  const housesCount = pluralize(count, ['дом', 'дома', 'домов']);

  return (
    <a className={styles['link']} href={url} target="blank" rel="noreferrer">
      <UIText1 as="span">
        {type === 'done' ? 'Сдал' : 'Строит'} {housesCount} {newbuildingText}
      </UIText1>
      <div className={styles['arrow']}>
        <IconActionArrowRight16 color="icon-main-default" />
      </div>
    </a>
  );
}
